const validValueNumAndLetter = (val) => {
    return /^[A-Za-z0-9]+$/.test(val)
}
const validIp = (val) => {
    return /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/.test(val)
}
const validPhone = (val) => {
    return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val)
}
// 对齐后端 gf password3 规则：长度6-18且必须含大小写字母、数字、特殊字符；
// 字符集限可见ASCII，比后端略严（后端会把中文/emoji当特殊字符放行），保证前端拦在前头不弹后端英文错
const validPwd = (val) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[\x21-\x7E]{6,18}$/.test(val)
}
export {
    validValueNumAndLetter,
    validIp,
    validPhone,
    validPwd,
}